// extracted by mini-css-extract-plugin
export default {"datasource":"datasource_datasource__6bUCy","title":"datasource_title__qPoFs"};